import { render, staticRenderFns } from "./DrawerLayout.vue?vue&type=template&id=5b331bc6&"
import script from "./DrawerLayout.vue?vue&type=script&lang=js&"
export * from "./DrawerLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports